export default "__VITE_ASSET__d8ee8c1a__"